import '../css/attempt-drawer.css';
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Chip, CircularProgress, Divider, InputBase, IconButton, List, ListItem, ListItemButton, 
  Paper, TextField, Typography }
  from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { useEssayContext } from "../contexts/context-essay";
import { AppHelper } from "../AppHelper";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ModeIcon from '@mui/icons-material/Mode';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ mt: 1 }}>
      <LinearProgress
        variant="determinate"
        {...props}
        sx={{
          height: 6,
          borderRadius: 999,
          backgroundColor: '#e2f3f0',
          '& .MuiLinearProgress-bar': {
            borderRadius: 999,
            background:
              'linear-gradient(90deg, rgba(45,212,191,1) 0%, rgba(13,148,136,1) 100%)'
          }
        }}
      />
    </Box>
  );
}

function AttemptDrawer({ isSa, essayAddClick, onEssaySelect, onEssayAttemptSelect, viewMode, showNewEssayButton }) {
  const {
    essayList,
    isEssayListLoaded,
    loadEssayList,
    essaySelect,
    isEssayListLoading
  } = useEssayContext();
  const oUser = AppHelper.userCacheGet();
  const [filterEssay, setFilterEssay] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(true);
  const [attemptSelectedId, setAttemptSelectedId] = React.useState('');
  
  const ui = {
    // Tailwind-ish palette used in your HTML
    slate100: '#f1f5f9',
    slate200: '#e2e8f0',
    slate300: '#cbd5e1',
    slate400: '#94a3b8',
    slate500: '#64748b',
    slate600: '#475569',
    slate700: '#334155',
    slate800: '#1e293b',
    white: '#ffffff',

    teal400: '#2dd4bf',
    teal600: '#0d9488',
    orange400: '#fb923c',
    orange500: '#f97316',
  };
  
  const shadowSm = '0 1px 2px rgba(0,0,0,0.05)';
  const shadowMd = '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)';
  const ringTeal = '2px solid rgba(20, 184, 166)';


  const isDraftSelected = React.useMemo(
    () => essayList.some(e => e.selected && e.status === 0),
    [essayList]
  );

  const hasInProgressEssays = useMemo(
    () => essayList.some(essay => essay.isInProgress),
    [essayList]
  );

  useEffect(() => {}, []);
  useEffect(() => {}, [essayList]);

 useEffect(() => {
  if (hasInProgressEssays) {
    const timer = setInterval(() => {
      loadEssayList(oUser); 
    }, 30000);
    return () => clearInterval(timer);
  }
}, [hasInProgressEssays, loadEssayList]); 

  useEffect(() => {
    if (isEssayListLoading != true && isEssayListLoading != false) return;
    setIsLoading(isEssayListLoading);
  }, [isEssayListLoading]);

  const listFilterEssay = () => {
    var _list = [...essayList];
    if (filterEssay && filterEssay.length > 0) {
      var _filterText = filterEssay.toLowerCase();
      _list = _list.filter(r =>
        r.topic.toLowerCase().includes(_filterText)
        || r.versionTitle.toLowerCase().includes(_filterText)
      );
    }

    // Filter out items whose essayId is in allAttempt
    const allAttempt = [];
    for (var i = 0; i < _list.length; i++) {
      var essayId = _list[i].essayId;
      var groupId = _list[i].groupId;

      if (groupId == null) continue;
      if (allAttempt.find(x => x == essayId)) continue;

      const attempts = _list.filter(
        x => x.groupId == groupId && x.essayId != essayId
      );

      if (attempts.length > 0) {
        _list[i].essayAttempt = [];

        for (var j = 0; j < attempts.length; j++) {
          _list[i].essayAttempt.push({
            essayId: attempts[j].essayId,
            createdOnUTC: attempts[j].tTitle,
            parentId: groupId,
            attemptId: _list[i].essayAttempt.length + 1
          });
          allAttempt.push(attempts[j].essayId);
        }

        const exists = attempts.filter(x => x.essayId == groupId).length > 0;
        if (!exists) {
          const firstAttempt = _list.find(x => x.essayId == groupId);
          if (firstAttempt) {
            _list[i].essayAttempt.push({
              essayId: groupId,
              createdOnUTC: firstAttempt.tTitle,
              parentId: groupId,
              attemptId: _list[i].essayAttempt.length + 1
            });
            allAttempt.push(groupId);
          }
        }
      }
    }

    const filteredList = _list.filter(item => !allAttempt.includes(item.essayId));
    return filteredList;
  };

  const visibleEssays = React.useMemo(
    () => listFilterEssay(),
    [essayList, filterEssay]
  );
  const filterEssayChange = (event) => {
    setFilterEssay(event.target.value);
  };
  const onSelect = (arg) => {
    if (onEssaySelect) onEssaySelect(arg);
    setAttemptSelectedId('');
  };

  const onSelectAttempt = (arg, parentEssay) => {
    if (onEssayAttemptSelect) onEssayAttemptSelect(arg, parentEssay);
    setAttemptSelectedId(arg.essayId);
  };

  const onAddClick = () => {
    if (essayAddClick) essayAddClick();
  };

  return (
    <Box
      sx={{
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%', 
        bgcolor: '#f1f5f9', 
        borderRight: '1px solid #e2e8f0'
      }}
    >
      {/* Header: NEW ESSAY button + Search Bar */}
      <Box
        sx={{
          p: 1.9,
          pb: 1.5, 
          bgcolor: '#fcfcfc',
          flexShrink: 0
        }}
      >
        {showNewEssayButton && (
          <Button
          onClick={onAddClick}
          fullWidth
          startIcon={<span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>＋</span>}
          sx={{
            backgroundColor: 'rgba(19,130,117)',
            '&:hover': { backgroundColor: '#0f6f70' }, 
            color: '#ffffff',
            fontWeight: 600,
            fontSize: '1rem',
            textTransform: 'uppercase',
            py: 0.9, 
            borderRadius: '10px', 
            boxShadow: '0 1px 3px rgba(0,0,0,0.18)', 
            mb: 2, 
            justifyContent: 'center',
            gap: 1,
          }}
        >
          NEW ESSAY
        </Button>
        )}
        <Box
          // component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 1,
            py: 0.2,
            height: 37, 
            borderRadius: 2,
            border: 1.2, 
            borderColor: '#e2e8f0', 
            // boxShadow: '0 2px 6px rgba(15,23,42,0.06)',
            '&:focus-within': {
              borderColor: 'transparent', 
              boxShadow: '0 0 0 2px rgba(13, 148, 136, 0.5)'
            }, 
            bgcolor: '#f8fafc', 
            marginBottom: 0.6,
          }}
        >
          <Box
            component="i"
            className="fas fa-search"
            sx={{
              left: '12px',
              fontSize: '14px',
              color: '#94a3b8',
              pointerEvents: 'none',
              marginLeft: 0.5, 
              marginTop: 0.7, 
              marginRight: 0.2
            }}
          />
          <InputBase
            sx={{ ml: 1, flex: 1, fontSize: '0.9rem', boxShadow: 'none' }}
            placeholder="Search essays..."
            inputProps={{ 'aria-label': 'Search essays' }}
            onChange={filterEssayChange}
          />
        </Box>
      </Box>

      {/* Essay Lists */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          pl: 1.7,
          pr: 1.7,
          pt: '3.5px',
          pb: 0,
          marginBottom: {
            xs: '0px', 
            sm: '60px'
          }, 
          '&::-webkit-scrollbar': {
            width: '5.4px'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#cbd5e1',
            borderRadius: '3px'
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#94a3b8'
          }
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              mt: 2,
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <List disablePadding sx={{ pt: 0, pb: 0 }}>
            {visibleEssays.map((rec, index) => {
              const isActive = rec.selected == 1;
              const isDraft = !rec.status || rec.status === 0;
              const score = Math.round(rec?.avgScoreP || 0);
              const hasAttempts = rec.essayAttempt && rec.essayAttempt.length > 0;
              const dateText = (rec.tTitle || '').split("'")[0] || rec.tTitle;
              let displayTitle = rec.viewTitle || rec.topic || '';
              if (!displayTitle || displayTitle.trim().length === 0) {
                displayTitle = isDraft ? 'Untitled Draft' : 'Untitled'
              }
              return (
                <ListItem
                  key={rec.essayId}
                  disablePadding
                  sx={{ borderBottom: 'none' }}
                >
                  <Box
                    onClick={() => onSelect(rec)}
                    sx={{
                      width: '100%',
                      mt: index === 0 && !isActive ? '-2px' : 0, 
                      mb: 1.79,
                      cursor: 'pointer',
                      borderRadius: 3,
                      overflow: 'hidden',
                      p: 2,
                      bgcolor: '#ffffff',
                      boxShadow: shadowSm, 
                      outline: isActive ? ringTeal : 'none', 
                      outlineOffset: '0px', 
                      transition: 'box-shadow 0.15s ease-out',
                      '&:hover': {
                        boxShadow: isActive ? 'none' : shadowMd,
                      }
                    }}
                  >
                    {/* Top section: dot + title + attempts badge + grade/sample pill */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      mb={1}
                    >
                      <Box display="flex" flexDirection="column" gap={0.5} sx={{ pr: 1, marginTop: '1px' }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              marginBottom: '1.8px', 
                              flexShrink: 0, 
                              bgcolor: isDraft
                                ? '#cbd5e1'
                                : score > 50
                                ? 'rgba(13, 148, 136)'
                                : 'rgba(249, 115, 22)',
                            }}
                          />
                          <Typography
                            title={rec.viewTitle}
                            sx={{
                              fontWeight: 700,
                              fontSize: '0.9rem',
                              mt: '-2px',
                              color: 'rgba(15,23,42,0.95)',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              lineHeight: 1.25
                            }}
                          >
                            {displayTitle}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Right pill: Sample or Grade */}
                      {rec.isSample == 1 ? (
                        <Chip
                          label="Sample"
                          size="small"
                          sx={{
                            fontSize: '0.65rem',
                            fontWeight: 900,
                            width: '70px', 
                            height: '20px', 
                            borderRadius: '999px',
                            bgcolor: '#f1f5f9',
                            color: '#64748b',
                            // px: 0.3, 
                            textTransform: 'uppercase',
                          }}
                        />
                      ) : (
                        <Chip
                          label={rec.grade}
                          size="small"
                          sx={{
                            mt: '-1px', 
                            fontSize: '0.63rem',
                            fontWeight: 900,
                            width: '36px', 
                            height: '19px', 
                            borderRadius: '999px',
                            bgcolor: '#f1f5f9',
                            color: '#64748b',
                            // px: 0.3, 
                            textTransform: 'uppercase',
                          }}
                        />
                      )}
                    </Box>

                    {/* Date + score */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-end"
                      mt={1}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'rgba(110, 125, 146)',
                          fontSize: '0.72rem'
                        }}
                      >
                        {dateText}
                      </Typography>
                      {!isDraft && score && (
                        <Typography
                          // variant="subtitle2"
                          sx={{
                            fontWeight: 800,
                            fontSize: '0.92rem',
                            color: 'rgba(15,23,42,0.9)', 
                          }}
                        >
                          {score}%
                        </Typography>
                      )}
                    </Box>

                    {/* Progress / status */}
                    <Box mt={-0.22}>
                      {rec.status > 0 ? (
                        rec.status == 5 ? (
                          <LinearProgressWithLabel
                            value={rec.avgScoreP}
                            recSelected={rec.selected}
                          />
                        ) : (
                          <>
                            {rec.isInProgress && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  mt: 0.5
                                }}
                              >
                                <CircularProgress size={18} thickness={5} />
                                <Typography
                                  variant="caption"
                                  sx={{ color: 'text.secondary' }}
                                >
                                  Analysing...
                                </Typography>
                              </Box>
                            )}
                          </>
                        )
                      ) : null}
                    </Box>

                    {isDraft && (
                    <Box
                      sx={{
                        mt: 0.5, 
                        width: '100%',
                        height: 24,
                        borderRadius: 1.5,
                        border: '1px dashed #cbd5e1',
                        bgcolor: '#f8fafc',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center', 
                      }}
                    >
                      {/* <ModeIcon sx={{ fontSize: '0.85rem', color: '#94a3b8', marginRight: 0.5}} /> */}
                      <Box
                        component="i"
                        className="fa-solid fa-pen-to-square"
                        sx={{
                          fontSize: '10px',
                          marginRight: '5px', 
                          color: '#94a3b8',
                          lineHeight: 1,
                        }}
                      />
                      <Typography
                      sx={{
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        color: '#94A3B8',
                        letterSpacing: '0.04em'
                      }}
                      >
                        DRAFT
                      </Typography>
                    </Box>
                    )}

                    {/* History attempts – only show when selected, card's history */}
                    {hasAttempts && (
                      <Box
                        sx={{
                          mt: 1.78,
                          pt: 0.9,
                          borderTop: '1px solid #e2e8f0',
                          bgcolor: 'rgba(251, 252, 253)',
                          mx: -2,
                          px: 2,
                          pb: 1
                        }}
                        onClick={e => {
                          e.stopPropagation();
                        }}
                      >
                        <Typography
                          sx={{
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            fontSize: '0.63rem',
                            fontWeight: 700,
                            color: '#94a3b8',
                            mb: 0.75,
                            mt: 0.55
                          }}
                        >
                          History
                        </Typography>

                        {rec.essayAttempt.map((rr, index) => {
                          const essay = essayList.find(
                            x => x.essayId === rr.essayId
                          );
                          const parentEssay = essayList.find(
                            x => x.essayId === rr.parentId
                          );
                          const descendingIndex =
                            rec.essayAttempt.length - index;
                          const attemptScore = Math.round(
                            essay?.avgScoreP || 0
                          );
                          const isAttemptActive =
                            attemptSelectedId === rr.essayId;
                          const attemptDate = (rr.createdOnUTC || '').split("'")[0] || rr.createdOnUTC;

                          return (
                            <Box
                              key={rr.essayId}
                              onClick={() =>
                                onSelectAttempt(essay, parentEssay)
                              }
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                py: 0.75,
                                px: 0.9,
                                borderRadius: 1.5,
                                cursor: 'pointer',
                                mb: -0.1,
                                bgcolor: isAttemptActive
                                  ? '#ffffff'
                                  : 'transparent',
                                '&:hover': {
                                  bgcolor: '#ffffff'
                                },
                                transition:
                                  'background-color 0.12s ease-out'
                              }}
                            >
                                <Typography
                                  sx={{
                                    fontSize: '0.73rem',
                                    fontWeight: 600,
                                    color: '#475569'
                                  }}
                                >
                                  Attempt {descendingIndex}
                                </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography
                                  // variant="caption"
                                  sx={{
                                    fontSize: '0.63rem',
                                    color: '#94a3b8'
                                  }}
                                >
                                  {attemptDate}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: '0.73rem',
                                    fontWeight: 700,
                                    color:
                                      attemptScore > 50
                                        ? 'rgba(13,148,136,1)'
                                        : 'rgba(249,115,22,1)',
                                  }}
                                >
                                  {attemptScore}%
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                </ListItem>
              );
            })}
          </List>
        )}
      </Box>
    </Box>
  );
}

export default AttemptDrawer;
